import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { SCHOOL } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

const mutateToggleSchool = async ({ id }: { id: string | number }) => {
	return await axiosAuth.patch(`${SCHOOL}${id}`);
};

const useToogleSchoolMutation = (
	queryParams?: UseMutationOptions<
		any,
		Error,
		{
			id: string | number;
		},
		unknown
	>
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: mutateToggleSchool,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({ queryKey: ["inventorySetup"], exact: false });
			queryParams?.onSuccess?.(data, variables, context);
		},
		...queryParams,
	});
};

export default useToogleSchoolMutation;
